import logo from '../../assets/images/logo.png'
import './navBar.scss'
const NavBar = () => {

  return (
    <div className={'nav-bar'}>
      <img src={logo} alt="" />
    </div>
  )
}


export default NavBar
